'use client';
/**
 * Проверяет, исполняется ли код в контексте браузера.
 */ const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

export { isBrowser };
//# sourceMappingURL=isBrowser.js.map
